import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import parse from "html-react-parser"
import "./blockTextGeneric.scss"
import Title from "../../common/title"
import { Link } from "gatsby"

const BlockTextGeneric = ({ content }) => {
  return (
    <section className="blk-text-generic blk-spacing">
      <Container>
        <Row>
          <Col md={6} xs={12} className="blk-text-generic-heading">
            <span className="caption">
              <span>
                {!content.block_text_caption ? "" : content.block_text_caption}
              </span>
            </span>
            <Title
              text={!content.block_text_title ? "" : content.block_text_title}
            />
          </Col>
          <Col md={6} xs={12} className="blk-text-generic-description">
            <p>
              {parse(
                !content.block_text_description?.processed
                  ? ""
                  : content.block_text_description?.processed
              )}
            </p>
            {content.block_text_link && (
              <Link className="blk-read-more" to={content.block_text_link.url}>
                {content.block_text_link.title}
              </Link>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default BlockTextGeneric
